export const DEFAULT_SUBDOMAIN: string = 'auraview';
export const DEFAULT_TENANT: string = 'auravant.com';